import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const sicCodesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'code',
    label: 'SIC code',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'riskScore',
    label: 'Risk score',
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
];

export const sicCodesListColumnsLabels = {
  code: 'SIC code',
  description: 'Description',
};

export const sicCodesListDefaultSorter = {};

export const sicCodesListSchema = {
  code: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const sicCodesListFiltersSchema = [
  {
    name: 'code',
    type: FilterType.TEXT,
    placeholder: 'Enter code...',
  },
  {
    name: 'description',
    type: FilterType.TEXT,
    placeholder: 'Enter description...',
  },
];
